import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

Router.prototype.goBack = function () {
  this.isBack = true
  window.history.go(-1)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import('@/pages/main.vue'),
      children: [
        {
          path: '/',
          name: 'homePageEntry',
          component: () => import('@/pages/homePageEntry.vue')
        }, {
          path: '/dailyActivity',
          name: 'dailyActivity',
          component: () => import('@/pages/activity/dailyActivity.vue')
        }, {
          path: '/immediatelyActivity',
          name: 'immediatelyActivity',
          component: () => import('@/pages/activity/immediatelyActivity.vue'),
          meta: {
            keepAlive: true,
          }
        }, {
          path: '/signIn',
          name: 'signIn',
          component: () => import('@/pages/signIn/signIn.vue')
        }, {
          path: '/activeDetail',
          name: 'activeDetail',
          component: () => import('@/pages/activity/activeDetail.vue')
        }, {
          path: '/activityList',
          name: 'activityList',
          component: () => import('@/pages/activity/activityList.vue'),
          meta: {
            keepAlive: true,
          }
        }, {
          path: '/useManual',
          name: 'useManual',
          component: () => import('@/pages/assistModule/useManual.vue')
        }, {
          path: '/wxSignIn',
          name: 'wxSignIn',
          component: () => import('@/pages/signIn/wxSignIn.vue')
        }, {
          path: '/setting',
          name: 'setting',
          component: () => import('@/pages/system/setting.vue')
        }, {
          path: '/systemNotice',
          name: 'systemNotice',
          component: () => import('@/pages/system/systemNotice.vue')
        },
        {
          path: '/orderDirectory',
          name: 'orderDirectory',
          component: () => import('@/pages/dpcSystem/orderDirectory.vue')
        },

        {
          path: '/oldPeopleOrder',
          name: 'oldPeopleOrder',
          component: () => import('@/pages/dpcSystem/oldPeopleOrder.vue')
        },
        {
          path: '/newOldPeopleOrder',
          name: 'newOldPeopleOrder',
          component: () => import('@/pages/dpcSystem/newOldPeopleOrder.vue')
        },
        {
          path: '/dpcLogin',
          name: 'dpcLogin',
          component: () => import('@/pages/dpcSystem/mobileDpc/dpcLogin.vue'),
          meta: {hiddenFullScreen: true},
        },
        {
          path: '/dpcTakeMeal',
          name: 'dpcTakeMeal',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/dpcTakeMeal.vue')
        },
        {
          path: '/personCenterDetail',
          name: 'personCenterDetail',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/personalCenter/personCenterDetail.vue')
        },
        {
          path: '/historyRecord',
          name: 'historyRecord',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/personalCenter/historyRecord.vue')
        },
        {
          path: '/order',
          name: 'order',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/personalCenter/order.vue')
        },
        {
          path: '/personCenter',
          name: 'personCenter',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/personalCenter/personCenter.vue')
        },
        {
          path: '/userFeedback',
          name: 'userFeedback',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/personalCenter/userFeedback.vue')
        },
        {
          path: '/NavigatePage',
          name: 'NavigatePage',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/worker/NavigatePage.vue')
        },
        {
          path: '/queryCardNumber',
          name: 'queryCardNumber',
          meta: {hiddenFullScreen: true},
          component: () => import('@/pages/dpcSystem/mobileDpc/worker/queryCardNumber.vue')
        },
        {
          path: '/nursingOrder',
          name: 'nursingOrder',
          component: () => import('@/pages/dpcSystem/nursingOrder.vue')
        },
        {
          path: '/outRecord',
          name: 'outRecord',
          component: () => import('@/pages/outRecord/outRecord.vue')
        },
        {
          path: '/outRecordCount',
          name: 'outRecordCount',
          component: () => import('@/pages/outRecord/outRecordCount.vue')
        },
        {
          path: '/outRecordWithBuilding',
          name: 'outRecordWithBuilding',
          component: () => import('@/pages/outRecord/outRecordWithBuilding.vue')
        },
        {
          path: '/questionnaireCode',
          name: 'questionnaireCode',
          component: () => import('@/pages/questionnaire/questionnaireCode.vue')
        },
        {
          path: '/questionnaireList',
          name: 'questionnaireList',
          component: () => import('@/pages/questionnaire/questionnaireList.vue')
        },
        {
          path: '/surveyQuestionnaire',
          name: '问卷填写',
          component: () => import('@/pages/archives/surveyQuestionnaire/surveyQuestionnaire.vue')
        },
        {
          path: '/outRecordStatistics',
          name: 'outRecordStatistics',
          component: () => import('@/pages/outRecordStatistics/outRecordStatistics.vue')
        },
        {
          path: '/outRecordStatisticsDetail',
          name: 'outRecordStatisticsDetail',
          component: () => import('@/pages/outRecordStatistics/outRecordStatisticsDetail.vue')
        },
        {
          path: '/oldpeopleConcernExamine',
          name: 'oldpeopleConcernExamine',
          component: () => import('@/pages/outRecordStatistics/oldpeopleConcernExamine.vue')
        },
        {
          path: '/poisonChickenSoup',
          name: 'poisonChickenSoup',
          component: () => import('@/pages/poisonChickenSoup.vue')
        },
        {
          path: '/homeSite/homeSiteSignIn',
          name: 'homeSiteSignIn',
          component: () => import('@/pages/homeSite/homeSiteSignIn.vue')
        },
        {
          path: '/fzkWorkbench/index',
          name: '福祉卡',
          component: () => import('@/pages/fzkWorkbench/index.vue'),
          meta: {hiddenFullScreen: true},
        },
        {
          path: '/dpcSystem/recharge',
          name: '充值',
          component: () => import('@/pages/dpcSystem/recharge.vue'),
          meta: {hiddenFullScreen: true},
        },
        {
          path: '/immediatelyOrder',
          name: 'immediatelyOrder',
          component: () => import('@/pages/dpcSystem/mobileDpc/immediatelyOrder.vue')
        },
        {
          path: '/immediatelyOrderDetail',
          name: 'immediatelyOrderDetail',
          component: () => import('@/pages/dpcSystem/mobileDpc/immediatelyOrderDetail.vue'),
          meta: {hiddenFullScreen: true},
        },
        {
          path: '/archives',
          name: '档案系统',
          component: () => import('@/pages/archives/layout.vue'),
          children: [
            {
              path: 'index',
              name: '我的工作台',
              component: () => import('@/pages/archives/index.vue')
            },
            {
              path: 'nursingTask',
              name: '我的护理任务',
              component: () => import('@/pages/archives/nursingTask/nursingTask.vue')
            },
            {
              path: 'oldpeopleNursingTask',
              name: '长者任务单',
              component: () => import('@/pages/archives/nursingTask/oldpeopleNursingTask.vue')
            },
            {
              path: 'oldpeople/choose',
              name: '选择长者',
              component: () => import('@/pages/archives/oldpeople/choose/choose.vue')
            },
            {
              path: 'nursingItem/choose',
              name: '选择护理项',
              component: () => import('@/pages/archives/nursingManage/nursingItem/choose/choose.vue')
            },
            {
              path: 'houseShow/buildingStatus',
              name: '楼栋情况',
              component: () => import('@/pages/archives/houseShow/buildingStatus.vue')
            },
            {
              path: 'houseShow/roomStatus',
              name: '房态图',
              component: () => import('@/pages/archives/houseShow/roomStatus.vue')
            },
            {
              path: '/dailyMenuStatistics',
              name: '餐厅出餐单',
              component: () => import('@/pages/dpcSystem/dailyMenuStatistics.vue'),
              meta: {hiddenFullScreen: true},
            },
            {
              path: '/dailyMenuStatisticsDetail',
              name: '餐厅出餐单明细',
              component: () => import('@/pages/dpcSystem/dailyMenuStatisticsDetail.vue'),
              meta: {hiddenFullScreen: true},
            },
            {
              path: '/myDailyMenuStatistics',
              name: '每日订单确认',
              component: () => import('@/pages/dpcSystem/myDailyMenuStatistics.vue'),
              meta: {hiddenFullScreen: true},
            }, {
              path: '/myDailyMenuStatisticsDetail',
              name: '每日订单确认明细',
              component: () => import('@/pages/dpcSystem/myDailyMenuStatisticsDetail.vue'),
              meta: {hiddenFullScreen: true},
            },
            {
              path: '/waterBottleRegister',
              name: '桶装水登记',
              component: () => import('@/pages/archives/logisticsManage/waterBottleRegister.vue'),
              meta: {hiddenFullScreen: true},
            },
            {
              path: '/sendWaterRecord',
              name: '桶装水任务单',
              component: () => import('@/pages/archives/logisticsManage/sendWaterRecord.vue'),
              meta: {hiddenFullScreen: true},
            },
            {
              path: '/applyWaterRecord',
              name: '我的桶装水记录',
              component: () => import('@/pages/archives/logisticsManage/applyWaterRecord.vue'),
              meta: {hiddenFullScreen: true},
            },


          ]
        },
      ]
    },

    {
      name: '404',
      path: '/404',
      component: () => import('@/pages/notFound.vue'),
    },

    //  此配置必须放在最后一位 404页面
    {
      path: '*',
      redirect: {
        name: "404"
      }
    }
  ],
  // 路由跳转滚动事件
  scrollBehavior(to, from, savedPosition) {
    let outerHeight = window.outerHeight// 整个浏览器窗口的高度
    let innerH = window.innerHeight// W3C-不包括菜单栏、工具栏以及滚动条等的浏览器窗口高度
    return {x: 0, y: -outerHeight - innerH}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js